import React, { Component } from 'react';
import { formatarReal } from '../../util/numberUtil';
import QRCodeCupomEncomenda from '../encomenda/QRCodeCupomEncomenda';

export default class ReciboCupomEncomendaAvulsa extends Component {

    linha() {
        return <hr id='printPageButton' style={{
            borderStyle: 'dashed',
            borderWidth: 3
        }}/>
    }

    exibirLimiteCupom() {
        return <div className='printer-element'>--</div>
    }

    exibirCabecalho(via) {
        const encomenda = this.props.encomenda
        return <React.Fragment>
            <tr>
                <th className="title" colSpan="3">
                    {encomenda.nomeEmpresa}
                    <br/>
                </th>
            </tr>
            <tr>
                <th colSpan="3">{encomenda.dataHoraVenda}</th>
            </tr>
            <tr>
                <td colSpan="3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'normal!important'}}>
                <td className='title' colSpan="3">
                    Via {via}
                </td>
            </tr>
            <tr style={{textAlign: 'center', fontWeight: 'normal!important'}}>
                <td className="title" colSpan="3">
                    Pedido: {encomenda.numeroPedido} · OS número: {encomenda.numeroOs}
                </td>
            </tr>
        </React.Fragment>
    }

    exibirCorpo() {
        const encomenda = this.props.encomenda
        return <React.Fragment>
            <tr align="left"><td colSpan="3"><strong>Rota: </strong>{encomenda.cidadeOrigem} à {encomenda.cidadeDestino}</td></tr>
            <tr align="left"><td colSpan="3">Itinerário: {encomenda.descricaoRotaItinerario} - {encomenda.dataItinerario}</td></tr>
            <tr><td colSpan="3">&nbsp;&nbsp;</td></tr>
            <tr align="left"><td colSpan="3"><strong>Remetente: </strong>{encomenda.nomeRemetente}</td></tr>
            <tr align="left"><td colSpan="3">Telefone: {encomenda.telefoneRemetente}</td></tr>
            <tr><td colSpan="3">&nbsp;&nbsp;</td></tr>
            <tr align="left"><td colSpan="3"><strong>Destinatário: </strong>{encomenda.nomeDestinatario}</td></tr>
            <tr align="left"><td colSpan="3">Telefone: {encomenda.telefoneDestinatario}</td></tr>
        </React.Fragment>
    }

    exibirProduto() {
        const encomenda = this.props.encomenda
        return <React.Fragment>
            <tr><td colSpan="3">Descrição Produto: {encomenda.descricao}</td></tr>
            <tr><td colSpan="3">Volumes: {encomenda.volumes}</td></tr>
            <tr><td colSpan="3">Forma de pagamento: {encomenda.descricaoFormaPagamento}</td></tr>
            <tr><td colSpan="3">Valor Total: {formatarReal((encomenda.valor || 0).toString())}</td></tr>
        </React.Fragment>
    }

    exibirCupom(via) {
        const encomenda = this.props.encomenda
        return <div>
            {this.exibirLimiteCupom()}
            <table className="printer-ticket">
                <thead>
                    {this.exibirCabecalho(via)}
                </thead>
                <tbody>
                    {this.exibirCorpo()}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    {this.exibirProduto()}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    <tr style={{textAlign: 'center'}}>
                        <td colSpan="3">
                            <QRCodeCupomEncomenda encomenda={{ idPedido: encomenda.numeroOs }}/>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan="3">Vendedor: {encomenda.codigoVendedor} - {encomenda.nomeVendedor}</td>
                    </tr>
                    {encomenda.situacao === 'CANCELADA' && <tr>
                        <td colSpan="3"><strong>CANCELADA - {encomenda.cancelamentoMotivo}</strong></td>
                    </tr>}
                    <tr>
                        <td colSpan="3">&nbsp;&nbsp;</td>
                    </tr>
                </tbody>
            </table>
            {this.exibirLimiteCupom()}
            {this.linha()}
        </div>
    }

    exibirEtiquetas() {
        const encomenda = this.props.encomenda
        if (encomenda.volumes) {
            return (<React.Fragment>
                {[...Array(encomenda.volumes)
                  .keys()].map(it => (<React.Fragment key={`volume-encomenda-avulsa${it}`}>
                    <h2>Rota: {encomenda.cidadeOrigem} à {encomenda.cidadeDestino}</h2>
                    <h2>Destino:</h2>
                    <div><span style={{ fontSize: 25 }}>{encomenda.cidadeDestino}</span></div>
                    <h2>Volume: {it + 1}/{encomenda.volumes}</h2>
                    <h2>OS: {encomenda.numeroOs}</h2>
                    <h2>Destinatário:</h2>
                    <div><span style={{ fontSize: 25 }}>{encomenda.nomeDestinatario}</span></div>
                    {it + 1 !== encomenda.volumes ? <hr className='mt-2' style={{ borderTop: '2px dashed' }} /> : ''}
                  </React.Fragment>))}
              </React.Fragment>
            )
        }
    }

    exibirReciboEntrega() {
        const encomenda = this.props.encomenda
        return (<>
            <div className="pagebreak"></div>
            {this.exibirLimiteCupom()}
            <div style={{marginBottom: '50px'}}>
                <h2>OS: {encomenda.numeroOs}</h2>
                <h2><span>RECIBO DE ENTREGA</span></h2>
                <h3>Declaro haver recebido as mercado-<br/>rias referentes à OS informada acima.</h3>
                <h2>OS: {encomenda.numeroOs}</h2>
                <h2>RG:</h2>
                <h2>CPF:</h2>
                <h2>Assinatura:</h2>
            </div>
            <hr style={{ borderTop: '2px dashed' }} />
            {this.exibirEtiquetas()}
            {this.exibirLimiteCupom()}
            {this.linha()}
        </>
        )
    }

    render() {
        const { referencias } = this.props
        return (
            <div>
                <div ref={referencias ? referencias.get('REMETENTE').referencia : null}>
                    {this.exibirCupom('Remetente')}
                </div>
                <div ref={referencias ? referencias.get('AGENCIA').referencia : null}>
                    {this.exibirCupom('Agência')}
                </div>
                <div ref={referencias ? referencias.get('DESTINATARIO').referencia : null}>
                    {this.exibirCupom('Destinatário')}
                </div>
                <div ref={referencias ? referencias.get('ENTREGA').referencia : null}>
                    {this.exibirCupom('Entrega')}
                </div>
                <div ref={referencias ? referencias.get('RECIBO_DE_ENTREGA').referencia : null}>
                    {this.exibirReciboEntrega()}
                </div>
            </div>
        )
    }

}
